import * as THREE from 'three';
import { getLightingQuality } from './lightingQuality.js';

export function createRenderer(canvas) {
  const lightingQuality = getLightingQuality();
  const renderer = new THREE.WebGLRenderer({
    canvas,
    antialias: false,
    powerPreference: 'high-performance',
  });
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, lightingQuality.renderer.pixelRatioCap));
  renderer.setSize(window.innerWidth, window.innerHeight, false);
  renderer.shadowMap.enabled = true;
  renderer.shadowMap.type = THREE.PCFSoftShadowMap;
  renderer.outputColorSpace = THREE.SRGBColorSpace;
  renderer.setClearColor(0x080808, 1);
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = lightingQuality.renderer.toneMappingExposure;
  return renderer;
}

export function createScene() {
  const scene = new THREE.Scene();
  // Match the cinematic demo baseline: near-black atmosphere and practical-led lighting.
  scene.background = new THREE.Color(0x080808);
  // Push fog further out for gameplay camera distance/pitch.
  scene.fog = new THREE.Fog(0x080808, 32, 90);

  // HTML reference ambient baseline.
  const ambient = new THREE.AmbientLight(0x1a1a2e, 0.15);
  scene.add(ambient);

  // A very subtle key for broad shape readability; practical lights stay dominant.
  const sun = new THREE.DirectionalLight(0x6f7488, 0.05);
  sun.position.set(18, 34, 14);
  sun.castShadow = false;
  sun.shadow.mapSize.set(1024, 1024);
  sun.shadow.camera.near = 1;
  sun.shadow.camera.far = 80;
  sun.shadow.camera.left = -30;
  sun.shadow.camera.right = 30;
  sun.shadow.camera.top = 30;
  sun.shadow.camera.bottom = -30;
  sun.shadow.bias = -0.0008;
  scene.add(sun);
  scene.add(sun.target);

  const rim = new THREE.DirectionalLight(0x19151f, 0.02);
  rim.position.set(-20, 10, -12);
  scene.add(rim);

  return { scene, sun };
}
